const m = {
  'Vai al tuo account': 'Go to your account',
  'Sicurezza da migliorare': 'Security needs improvement',
  'Buongiorno': 'Good morning',
  'Buon pomeriggio': 'Good afternoon',
  'Buonasera': 'Good evening',
  'Cliente': 'Customer',
  'prodotto': 'product',
  'prodotti': 'products',
  'da pagare': 'to pay',
  'Sicurezza': 'Security',
  'Attiva la verifica in due fasi': 'Enable two-step verification',
  'Personalizzare': 'Customize',
  'Prodotti': 'Products',
  'I miei servizi': 'My services',
  'Tutto': 'All',
  'scad. {d}': 'exp. {d}',
  'Auto': 'Auto',
  'Manuale': 'Manual',
  'Hosting e Domini': 'Hosting & Domains',
  'PEC & Trust Services': 'PEC & Trust Services',
  'Cloud Computing': 'Cloud Computing',
  'Sito web': 'Website',
  'Hosting': 'Hosting',
  'Domini': 'Domains',
  'Certificato SSL': 'SSL Certificate',
  'Posta Certificata': 'Certified email (PEC)',
  'SPID': 'SPID',
  'Firma Digitale': 'Digital signature',
  'Server Dedicati': 'Dedicated servers',
  'VPS': 'VPS',
  'Storage': 'Storage',
  'NAS Synology': 'Synology NAS',
  'Housing': 'Housing',
};
export default m;
